/* ============================================================================
   Back to Top Button
   ============================================================================
   Shows button after scrolling down, smoothly scrolls back to top
   ========================================================================== */

class BackToTop {
  constructor() {
    this.button = document.querySelector('[data-back-to-top]');
    if (!this.button) return;

    this.threshold = 400; // Show button after scrolling 400px
    this.isVisible = false;

    this.init();
  }

  init() {
    this.setupScrollListener();
    this.setupClickHandler();
  }

  setupScrollListener() {
    let ticking = false;

    const checkScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldShow = scrollTop > this.threshold;

      if (shouldShow !== this.isVisible) {
        this.isVisible = shouldShow;
        this.button.classList.toggle('is-visible', shouldShow);
      }

      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(checkScroll);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    checkScroll(); // Initial check
  }

  setupClickHandler() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();

      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      // Focus management for accessibility
      document.querySelector('body').focus();
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BackToTop();
  });
} else {
  new BackToTop();
}
